export type TQueryResult<T = unknown> =
  | { data: T; error?: undefined; meta?: {} | undefined }
  | { data?: undefined; error: TQueryError; meta?: {} | undefined };

// Returned by processResponse when a response fails Zod validation against
// the operation's schema. Surfaced as a typed error so the UI gets
// `data: undefined` rather than crashing on a malformed payload.
export const SCHEMA_MISMATCH_STATUS = 'SCHEMA_MISMATCH';

export const GRAPHQL_ERROR_STATUS = 'GRAPHQL_ERROR';

// Services raise domain errors with a machine-readable code so clients branch on
// `code` instead of matching message text, which changes without warning.
export type TGraphQLErrorExtensions = {
  code?: string;
  statusCode?: number;
  detail?: Record<string, unknown>;
};

export type TQueryError = {
  status: number | string;
  data?: unknown;
  message?: string;
  error?: string;
  extensions?: TGraphQLErrorExtensions;
};

export type TGraphQLRequest = {
  document: string;
  variables?: Record<string, any>;
};

export type TGraphQLResponse = {
  data?: any;
  errors?: Array<{ message: string; extensions?: TGraphQLErrorExtensions }>;
  message?: string;
};
